import Vue from "vue";

import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import QRCode from "vue-qr";
import TreeSelect from "@riophae/vue-treeselect";
import "@/assets/styles/vuetreeselect.scss";
import Print from "@/utils/print";

Vue.component("QRCode", QRCode);
Vue.component("TreeSelect", TreeSelect);
Vue.component("WangEditor", Editor);
Vue.component("WangEditorToolbar", Toolbar);
Vue.use(Print);
